import { render, staticRenderFns } from "./OrderDetailSection.vue?vue&type=template&id=12c084d9&scoped=true"
import script from "./OrderDetailSection.vue?vue&type=script&lang=js"
export * from "./OrderDetailSection.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailSection.vue?vue&type=style&index=0&id=12c084d9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c084d9",
  null
  
)

export default component.exports